import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import SelectDropdown from "src/components/shared/inputs/SelectDropdown/SelectDropdown";
import FormField from "../FormField/FormField";

import { useClinicContext } from "src/contexts/clinic/ClinicProvider";

import { EMRHubType } from "src/services/emr/types";

type ClinicFieldType = {
  idPrefix: string;
  hub: EMRHubType | undefined;
  clinicId: string | undefined;
};

const useHubClinicsOfUser = (hub: EMRHubType | undefined) => {
  const { allClinicInfo } = useClinicContext();

  return useMemo(
    () =>
      (hub?.associatedClinics ?? []).filter((clinic) =>
        allClinicInfo.some((member) => member.id === clinic.clinicId)
      ),
    [hub?.associatedClinics, allClinicInfo]
  );
};

const ClinicField = ({ idPrefix, hub, clinicId }: ClinicFieldType) => {
  const { t } = useTranslation();
  const clinics = useHubClinicsOfUser(hub);

  const clinic = clinics.find((candidate) => candidate.clinicId === clinicId);
  if (clinics.length < 2 || !clinic) return null;

  return (
    <FormField label={t("Clinic")} labelId={`${idPrefix}-clinic-label`}>
      <SelectDropdown
        id={`${idPrefix}-clinic-dropdown`}
        labelId={`${idPrefix}-clinic-label`}
        disabled
        dropdownOptions={[{ displayName: clinic.name, value: clinic.clinicId }]}
        value={clinic.name}
        handleChange={() => {}}
      />
    </FormField>
  );
};

export default ClinicField;
